import { createApp } from 'vue';
// @ts-ignore
import HomePage from './ui/components/5-pages/HomePage/HomePage.vue';
import './tailwind.css';
import './ui/styles/main.scss';
import { createPinia } from 'pinia';
// @ts-ignore
import { makeServer } from './mockServer.js';
import '@varlet/touch-emulator';

const pinia = createPinia();

// @ts-ignore
if (import.meta.env.DEV === true) {
  console.log('Starting MirageJS mock server.');
  makeServer();
}

let appMountElement = document.getElementById('app');
if (appMountElement) {
  const app = createApp(HomePage);
  app.use(pinia).mount(appMountElement);
}
